import {observer} from "mobx-react";
import {useStore} from "@/store";
import React, {useEffect} from "react";
import styled from "styled-components";
import Button from "@/components/common/Button";
import {setFindItemId} from "@/utils/menu";
import {SIZES} from "@/components/constants";
import {useMediaQuery} from "react-responsive";
import {useRouter, useSearchParams} from "next/navigation";

const CooperationDetailModal = observer(({handleCloseModal, modalDepth, confirmFunc, data}) => {
    const {boardDetailStore, navigationStore} = useStore();
    const router = useRouter();
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const formWrapId = "691ff7892df644bf3e6fdd92";
    const params = useSearchParams();
    const menuId = params.get("menu-id");
    useEffect(() => {
        boardDetailStore.getCooperationBrandOrder().then();
    }, []);
    const getDeepestFirstChild = (node) => {
        if (!node) return null;
        if (Array.isArray(node)) {
            if (node.length === 0) return null;
            return getDeepestFirstChild(node[0]);
        }
        if (node.children && Array.isArray(node.children) && node.children.length > 0) {
            return getDeepestFirstChild(node.children[0]);
        }
        return node;
    }
    return(
        <OrderWrapper>
            <div className={"wrap"}>
            {
                data &&
                <div className={"order-wrap"}>
                    {
                        data.data.files && data.data.files.length > 0 &&
                        <div className={"logo-area"}>
                            <div className={"logo-wrap"}>
                                <img src={data.data.files[0].path} alt={"협력사 로고"}/>
                            </div>
                        </div>
                    }
                    <div className={"coop-desc-info"}>
                        <div className={"coop-desc"}>
                            <div className={"loc-title"}>{data.data.locationTitle}</div>
                            <div className={"title"}>{data.data.title}</div>
                        </div>
                        <div className={"coop-info"}>
                            <div className={"all-address"}>
                                    {data.data.address}&nbsp;{data.data.detailAddress}
                            </div>
                            {
                                data.data.tel &&
                                <div className={"tel-inner inner-info"}>전화번호 : <span
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const phone = data.data.tel.replace(/-/g, "");
                                        if (typeof window !== "undefined") {
                                            window.location.href = `tel:${phone}`;
                                        }
                                    }}
                                >{data.data.tel}</span></div>
                            }
                            {
                                data.data?.homepageUrl &&
                                <div className={"url-inner inner-info"}>회사 홈페이지 : <span
                                    onClick={() => {
                                        window.open(
                                            data.data?.homepageUrl,
                                            "_blank",
                                            "noopener,noreferrer"
                                        );
                                    }}
                                >{data.data?.homepageUrl}</span></div>
                            }

                        </div>
                    </div>
                </div>
            }
            {
                boardDetailStore.cooperationBradOrderList && boardDetailStore.cooperationBradOrderList.length > 0 &&
                <div className={"brand-order-wrap"}>
                    <div className={"brand-order-title"}>📦 브랜드 별 발주일 안내</div>
                    <div className={"brand-order-table"}>
                        <div className={"order-table-title"}>
                            {
                                !isTablet ?
                                    <>
                                        <div className={"pc-title"}>브랜드(Maker)</div>
                                        <div className={"pc-title"}>발주 마감일정</div>
                                    </>
                                    :
                                    <div className={"mo-title"}>브랜드(Maker)-발주 마감일정</div>
                            }
                        </div>
                        <div className={"order-table-body"}>
                            {
                                boardDetailStore.cooperationBradOrderList.map((item, idx) =>
                                    <div className={"list"} key={idx}>
                                        {
                                            !isTablet ?
                                                <>
                                                    <div className={"inner"}>{item.brand}</div>
                                                    <div className={"inner"}>{item.endDate}</div>
                                                </>
                                                :
                                                <div className={"inner"}>
                                                    {item.brand}<br />
                                                    -{item.endDate}
                                                </div>
                                        }
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            }
            </div>
            <div className={"button-area"}>
                <Button
                    type="fill"
                    size="l"
                    text="신청 하기"
                    full={true}
                    round={true}
                    onClickFunc={async () => {
                        const subList = setFindItemId(navigationStore.navigateList, formWrapId);
                        if(subList.children){
                            const lastChildNode = getDeepestFirstChild(subList);
                            handleCloseModal(modalDepth);
                            const pagePath  = navigationStore.setFilterPageUrl(lastChildNode, undefined, menuId);
                            router.push(pagePath);
                        }
                    }}
                />
            </div>
        </OrderWrapper>
    )
});
const OrderWrapper = styled.div`
    height: calc(100% - 44px);
    position: relative;
    padding: 0 0 84px;
    margin-top: 44px;
    .wrap{
        height: 100%;
        overflow: auto;
        padding: 0 6px;
    }
    .order-wrap{
        .logo-area{
            padding: 0 50px;
            .logo-wrap{
                width: 100%;
                padding: 8px;
                border: 1px solid #E6E6E6;
                img{
                    width: 100%;
                }
            }
        }
        .coop-desc-info{
            padding: 16px;
            .coop-desc{
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 10px;
                .loc-title{
                    height: 24px;
                    padding: 0 8px;
                    display: flex;
                    align-items: center;
                    background-color: #4939B1;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 18px;
                    letter-spacing: 0.28px;
                    color: #fff;
                    border-radius: 99px;
                }
                .title{
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 28px;
                    color: #4939B1;
                }
            }
            .coop-info{
                .all-address{
                    font-size: 16px;
                    margin-bottom: 10px;
                    font-weight: 400;
                    line-height: 24px;
                    color: #333333;
                }
                .inner-info{
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 22px;
                    color: #666666;
                    
                    
                    span{
                        text-decoration: underline;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .brand-order-wrap{
        padding: 16px;
        border: 1px solid #f2f2f2;
        .brand-order-title{
            font-size: 12px;
            font-weight: 700;
            line-height: 18px;
            color: #666666;
            margin-bottom: 8px;
        }
        .brand-order-table{
            .order-table-title{
                display: flex;
                align-items: center;
                border-bottom: 1px solid #DEDCEC;
                background-color: #F3F2F9;
                .pc-title{
                    flex: 0 0 50%; 
                    max-width: 50%;
                    //overflow: hidden;
                    //text-overflow: ellipsis;
                    //white-space: nowrap;
                    padding: 12px 8px;
                    height: 100%;
                    min-height: 44px;
                    font-size: 14px;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                    color: #1B0751;
                }  
            }
            .order-table-body{
                .list{
                    display: flex;
                    align-items: center;
                    background-color: #fff;
                    & + .list{
                        border-top: 1px solid #E6E6E6;
                    }
                    .inner{
                        flex: 0 0 50%;
                        max-width: 50%;
                        //overflow: hidden;
                        //text-overflow: ellipsis;
                        //white-space: nowrap;
                        height: 100%;
                        min-height: 54px;
                        display: flex;
                        align-items: center;
                        padding: 16px 8px;
                        font-size: 14px;
                        color: #38304D;
                        font-weight: 400;
                    }
                }
            }
        }
    }
    .button-area{
        position: absolute;
        bottom: 0;
        width: 100%;
    }
    @media (max-width: ${SIZES.TABLET}) {
        height: calc(100% - 25px);
        margin-top: 0;
        .wrap{
            height: 100%;
            overflow: auto;
            margin-top: 20px;
        }
        .order-wrap{
            .logo-area{
                margin-bottom: 10px;
            }
        }
        .brand-order-wrap{
            .brand-order-table{
                .order-table-title{
                    display: block;
                    padding: 12px 8px;
                    .mo-title{
                        font-size: 14px;
                        font-weight: 700;
                        line-height: 22px;
                    }
                }
                .order-table-body{
                    .list{
                        display: block;
                        & + .list{
                            border-top: 1px solid #E6E6E6;
                        }
                        .inner{
                            max-width: 100%;
                            min-height: 60px;
                            padding: 8px;
                            font-size: 14px;
                            color: #38304D;
                            font-weight: 400;
                        }
                    }
                }
            }
        }
        .button-area{
            bottom: 20px;
        }
    }
`

export default CooperationDetailModal